/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Bddk_CInputs */

const tr_mesafeli_s6_bddk_c = /** @type {(inputs: Mesafeli_S6_Bddk_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sayfasından veya e-postadaki bağlantı üzerinden başlatılır.`)
};

const en_mesafeli_s6_bddk_c = /** @type {(inputs: Mesafeli_S6_Bddk_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`page or via the link in the email.`)
};

const de_mesafeli_s6_bddk_c = /** @type {(inputs: Mesafeli_S6_Bddk_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder über den Link in der E-Mail.`)
};

const ru_mesafeli_s6_bddk_c = /** @type {(inputs: Mesafeli_S6_Bddk_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`или по ссылке из письма.`)
};

/**
* | output |
* | --- |
* | "page or via the link in the email." |
*
* @param {Mesafeli_S6_Bddk_CInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_bddk_c = /** @type {((inputs?: Mesafeli_S6_Bddk_CInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Bddk_CInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_bddk_c(inputs)
	if (locale === "de") return de_mesafeli_s6_bddk_c(inputs)
	if (locale === "ru") return ru_mesafeli_s6_bddk_c(inputs)
	return tr_mesafeli_s6_bddk_c(inputs)
});